module.exports = __webpack_public_path__ + "static/media/white-arrow-right.7ef17c69.svg";